import React from "react";
import {google, office365, outlook, yahoo} from "calendar-link";
import {Popover, Button} from "antd";
import Environment from "~/services/Environment";
import type { Scholarship } from "~/models/Scholarship";

interface AddDeadlineToCalendarProps {
  scholarship: Scholarship;
}

interface CalendarLink {
  title: string;
  url: string;
}

class AddDeadlineToCalendar extends React.Component<AddDeadlineToCalendarProps> {

    private allCalendars: CalendarLink[];

    constructor(props: {scholarship: Scholarship}) {
        super(props);

        const { scholarship } = props;


        const scholarshipUrl = `${Environment.clientUrl}/scholarship/${scholarship.slug}`;

        const event = {
            title: `Deadline for ${scholarship.name}`,
            description: `View Scholarship: ${scholarshipUrl}.\n\n${scholarship.description}`,
            start: scholarship.deadline,
            end: scholarship.deadline,
            location: scholarshipUrl,
        };

        const gCalUrl = google(event)
        const outlookUrl = outlook(event)
        const officeUrl = office365(event)
        const yahooUrl = yahoo(event)

        this.allCalendars = [
            {title: "Google Calendar", url: gCalUrl},
            {title: "Outlook Calendar", url: outlookUrl},
            {title: "Office365 Calendar", url: officeUrl},
            {title: "Yahoo Calendar", url: yahooUrl},
        ]
    }

    render() {

        let calendarOptions = this.allCalendars.map(calendar => (
            <React.Fragment key={calendar.url}>
                <a href={calendar.url} target="_blank" rel="noopener noreferrer">
                    {calendar.title}
                </a>
                <br />
            </React.Fragment>
        ))

        return (
            <div>
                <Popover 
                    trigger={"click"} 
                    title={<b>Choose Calendar</b>} 
                    content={calendarOptions} 
                    placement={"bottom"} 
                    overlayStyle={{fontSize: "1.1rem"}}>
                    <Button className="my-3">Save Deadline To My Calendar</Button>
                </Popover>
            </div>
        )
    }
}

export default AddDeadlineToCalendar;